import type { FunctionComponent } from 'react';
import { useCallback, useMemo } from 'react';

import { ALEX_PROXY_MODE, getAlexProxyMode } from '@shared/environment';

import { DevToolsToggle } from '../DevToolsToggle';
import { turnAlexProxyOff, turnAlexProxyOn } from './RecordToggleService';
import styles from './RecordToggle.module.scss';

export const RecordToggle: FunctionComponent = () => {
    const alexProxyMode = useMemo(getAlexProxyMode, []);

    const toggleAlexProxyMode = useCallback((isActive: boolean) => {
        if (isActive) {
            turnAlexProxyOn();
        } else {
            turnAlexProxyOff();
        }
    }, []);

    return (
        <DevToolsToggle
            active={alexProxyMode === ALEX_PROXY_MODE.REMOTE}
            className={styles.toggle}
            label="Recording"
            onToggle={toggleAlexProxyMode}
        />
    );
};
